import React from 'react';
import { useData } from '../../context/DataContext';
import { computeGroupStats } from '../../utils/calculations';

export const SubjectAvgCards = () => {
  const { getScopedStudents } = useData();

  const scoped = getScopedStudents();
  const stats = computeGroupStats(scoped);

  const n = stats.participated;
  const scoreText = (v) => (n > 0 ? Math.round(v) + '%' : '—');

  return (
    <div className="mb-8 select-none">
      <h3 className="text-xl font-bold text-gray-800 mb-4">Subject-wise Average Score</h3>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        {/* English card */}
        <div className="bg-white rounded-2xl p-5 shadow border-l-4" style={{ borderColor: '#2a6a4a' }}>
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center gap-2 font-bold text-gray-800 text-lg">
              <span>📗</span> English
            </div>
            <span className="text-xs text-gray-500 font-semibold">{n} students</span>
          </div>
          <p className="text-4xl font-black" style={{ color: '#2a6a4a' }}>
            {scoreText(stats.avgEnglish)}
          </p>
          <p className="text-xs text-gray-500 mt-1">Average score across all assessed students</p>
        </div>

        {/* Math card */}
        <div className="bg-white rounded-2xl p-5 shadow border-l-4" style={{ borderColor: '#1e3a9a' }}>
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center gap-2 font-bold text-gray-800 text-lg">
              <span>📐</span> Mathematics
            </div>
            <span className="text-xs text-gray-500 font-semibold">{n} students</span>
          </div>
          <p className="text-4xl font-black" style={{ color: '#1e3a9a' }}>
            {scoreText(stats.avgMath)}
          </p>
          <p className="text-xs text-gray-500 mt-1">Average score across all assessed students</p>
        </div>
      </div>
    </div>
  );
};
export default SubjectAvgCards;
